import type {
  OverlayGroup,
  OverlayItem,
} from "@/features/map/components/LayerGroupControl";

export interface IsOverlayToggleableParams {
  /** レイヤーパネルに出しているグループ一覧。 */
  overlayGroups: OverlayGroup[];
  /** 操作を抑止しているグループの見出し（地図出力中のゼンリン / GEOSPACE 等）。 */
  lockedGroupTitles?: string[];
  /** 判定するレイヤー名。 */
  name: string;
}

const hasToggleableLayer = (items: OverlayItem[], name: string): boolean =>
  items.some((item) =>
    item.type === "folder"
      ? hasToggleableLayer(item.items, name)
      : item.name === name && !item.disabled && !item.locked
  );

/**
 * そのレイヤーをレイヤーパネルから ON にできる状態かを判定する純粋関数。
 *
 * パネルに無いレイヤーを外から ON にすると、利用者がパネルから OFF に戻せなくなる。
 * disabled / locked のレイヤーや操作抑止中のグループも、利用者自身が切り替えられない
 * 状態なので false とする。
 */
export const isOverlayToggleable = ({
  overlayGroups,
  lockedGroupTitles,
  name,
}: IsOverlayToggleableParams): boolean =>
  overlayGroups.some(
    (group) =>
      !lockedGroupTitles?.includes(group.title) &&
      hasToggleableLayer(group.layers, name)
  );
